import { Box, Button, Tooltip } from '@mui/material';
import React, { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { RootState } from '../../../redux/reducers';
import AddIcon from '@mui/icons-material/Add';
import PurchaseOrderFormGoodsElement from './PurchaseOrderFormGoodsElement';
import {
    createNewEmptyGoodsBatchEntityForPurchaseOrder,
    setGoodsBatchEntitiesForPurchaseOrder,
} from '../../../redux/actions/purchaseOrderActions';
import { WarehouseClient } from '../../../api/Extensions';

type PurchaseOrderFormGoodsProps = {
    canChangeValuableInfo: boolean;
};

export default function PurchaseOrderFormGoods(props: PurchaseOrderFormGoodsProps): ReactElement {
    const { canChangeValuableInfo } = props;

    const purchaseOrder = useAppSelector((state: RootState) => state.purchaseOrderForm.purchaseOrder);
    const purchaseOrderedGoods = useAppSelector((state: RootState) => state.goodsToPurchaseOrderForm.goodBatchEntities);

    // if purchaseOrderId exists, get all goods for purchaseOrder and set them as existing goods
    useEffect(() => {
        if (!!purchaseOrder?.id) {
            WarehouseClient.getAllGoodsForPurchaseOrder(purchaseOrder.id).then((res) => {
                dispatch(
                    setGoodsBatchEntitiesForPurchaseOrder({
                        goods: res,
                        receptionOrders: purchaseOrder.receptionOrders ?? [],
                    }),
                );
            });
        }
    }, [purchaseOrder]);

    const dispatch = useAppDispatch();

    const addNewPurchaseOrderGood = () => {
        dispatch(createNewEmptyGoodsBatchEntityForPurchaseOrder());
    };

    return (
        <Box
            sx={{
                overflow: 'auto',
                p: 2,
            }}
        >
            <Box>
                {purchaseOrderedGoods?.map((purchaseOrderGoods) => {
                    return (
                        <Box key={purchaseOrderGoods.index} sx={{ mb: 2 }}>
                            <PurchaseOrderFormGoodsElement
                                canChangeValuableInfo={canChangeValuableInfo}
                                purchaseOrderedGoodsBatchEntity={purchaseOrderGoods}
                                addNewGoods={addNewPurchaseOrderGood}
                            />
                        </Box>
                    );
                })}
                <Tooltip title="Ubaci novi artikal">
                    <div>
                        <Button
                            key={'addNewArticle'}
                            variant="outlined"
                            color="primary"
                            sx={{
                                width: '100%',
                                height: 60,
                            }}
                            onClick={addNewPurchaseOrderGood}
                        >
                            <AddIcon sx={{ m: 'auto' }} />
                        </Button>
                    </div>
                </Tooltip>
            </Box>
        </Box>
    );
}
